import { Component, Input, OnInit } from '@angular/core';
import { EstimateResponse } from '../../../domains/payment/models/payment.model';

@Component({
  selector: 'gdp-footer-card',
  templateUrl: './footer-card.component.html',
  styleUrls: ['./footer-card.component.scss']
})
export class FooterCardComponent implements OnInit {
  @Input() estimate: EstimateResponse;
  @Input() locale: string;

  ngOnInit(): void {
    
  }
}